window.addEventListener('DOMContentLoaded', () => {
	const recurlyLoadedEvent = document.createEvent('CustomEvent');
	recurlyLoadedEvent.initCustomEvent('MmgsRecurlyLoaded', true, false);

	function mmgsCheckForRecurly(counter) {
		if (typeof window.recurly === 'undefined' && counter < 20) {
			setTimeout(() => mmgsCheckForRecurly(counter + 1), 500);
		} else {
			window.dispatchEvent(recurlyLoadedEvent);
		}
	}

	mmgsCheckForRecurly(0);
});

/**
 * Checkout page.
 */
window.addEventListener('MmgsRecurlyLoaded', () => {
	if (!getElement('mmg-osp-payment-form')) {
		return;
	}

	var currentCardElements;

	function getElement(id) {
		return document.getElementById(id);
	}

	// TODO: Mv to separate file
	function smoothScroll(destination = 0, scrollDuration = 650) {
		if (typeof destination !== 'number' && typeof destination !== 'object') {
			throw "The 'destination' param must be either int or object type";
		}

		let scrollTo =
			typeof destination === 'object'
				? window.pageYOffset + destination.getBoundingClientRect().top
				: destination;

		const anchorHeightAdjust = 150;
		if (scrollTo > anchorHeightAdjust) {
			scrollTo = scrollTo - anchorHeightAdjust;
		}

		let cosParameter = (window.pageYOffset - scrollTo) / 2;
		let scrollCount = 0;
		let oldTimestamp = window.performance.now();

		function step(newTimestamp) {
			let tsDiff = newTimestamp - oldTimestamp;
			/**
			 * Performance.now() polyfill loads late so passed-in timestamp is a larger offset
			 * on the first go-through than we want so adjusting the difference here.
			 */
			if (tsDiff > 100) {
				tsDiff = 30;
			}

			scrollCount += Math.PI / (scrollDuration / tsDiff);

			if (scrollCount >= Math.PI) {
				return;
			}

			const moveStep = Math.round(
				scrollTo + cosParameter + cosParameter * Math.cos(scrollCount)
			);
			window.scrollTo(0, moveStep);
			oldTimestamp = newTimestamp;
			window.requestAnimationFrame(step);
		}

		window.requestAnimationFrame(step);
	}

	function removeErrorMessage() {
		const message_container = getElement('mmg-osp-errors');
		if (null !== message_container.firstElementChild) {
			message_container.firstElementChild.remove();
		}
	}
	function showError(message) {
		const errorContainer = getElement('mmg-osp-errors');
		if (!message || message.length === 0) {
			if (errorContainer.firstElementChild) {
				errorContainer.firstElementChild.remove();
				return;
			}
		}
		const messageNode =
			errorContainer.firstElementChild || document.createElement('p');
		messageNode.innerText = message;
		errorContainer.appendChild(messageNode);
		smoothScroll(errorContainer, 650);
	}

	function recurlyError(err) {
		if (err.fields !== undefined) {
			err.fields.forEach(field => {
				if (['number', 'month', 'year'].includes(field)) {
					document
						.querySelector(`#mmg-osp-recurly-card .recurly-element-card`)
						.classList.add('error');
				}
			});
		}
		showError(err.message);
	}

	function setPaymentMethod(type = 'credit_card') {
		removeErrorMessage();
		getElement('mmg-osp-submit').classList.add('hidden');
		getElement('mmg-osp-recurly-card').classList.add('hidden');

		getElement('mmg-osp-paypal-submit').classList.add('hidden');
		getElement('mmg-osp-paypal-note', true).classList.add('hidden');

		getElement('mmg-osp-apple-pay-submit').classList.add('hidden');
		getElement('mmg-osp-apple-pay-container').classList.add('hidden');

		getElement('mmg-osp-google-pay-button-container').classList.add('hidden');
		getElement('mmg-osp-google-pay-container').classList.add('hidden');
		if (type === 'credit_card') {
			getElement('mmg-osp-recurly-card').classList.remove('hidden');
			getElement('mmg-osp-submit').classList.remove('hidden');
		} else if (type === 'apple_pay') {
			getElement('mmg-osp-apple-pay-container').classList.remove('hidden');
			getElement('mmg-osp-apple-pay-submit').classList.remove('hidden');
		} else if (type === 'google_pay') {
			getElement('mmg-osp-google-pay-container').classList.remove('hidden');
			getElement('mmg-osp-google-pay-button-container').classList.remove('hidden');
		} else if (type === 'paypal') {
			getElement('mmg-osp-paypal-submit').classList.remove('hidden');
			getElement('mmg-osp-paypal-note', true).classList.remove('hidden');
		}
	}

	function setLoadingState(state) {
		const allSubmitBtns = document.querySelectorAll('#mmg-osp-submit-buttons button');
		const payMethods = getElement('mmg-osp-payment-methods');
		const countryCurrency = getElement('mmg-osp-country-currency');
		const preloaderClassName = 'mmgs-preloader';
		if (state) {
			for (var i = 0; i < allSubmitBtns.length; i++) {
				allSubmitBtns[i].disabled = true;
				allSubmitBtns[i].classList.add(preloaderClassName);
			}
			payMethods.classList.add(preloaderClassName);
			countryCurrency.classList.add(preloaderClassName);
		} else {
			for (var j = 0; j < allSubmitBtns.length; j++) {
				allSubmitBtns[j].disabled = false;
				allSubmitBtns[j].classList.remove(preloaderClassName);
			}
			payMethods.classList.remove(preloaderClassName);
			countryCurrency.classList.remove(preloaderClassName);
		}

		const tcCheckbox = getElement('mmg-osp-tc-checkbox', true);
		if (tcCheckbox) {
			disableSubmitButtons(!tcCheckbox.checked);
		}
	}

	function createSubscription(token, paymentMethod) {
		const data = {
			action: 'handle_checkout_request',
			token: token, // todo: check token
			three_d_token: getElement('mmg-osp-three-d-secure-action-token-id').value,
			three_d_secure_checkout: getElement('mmg-checkout-with-3ds').value,
			payment_method: paymentMethod,
			email: getElement('mmg-osp-email').value,
			first_name: getElement('mmg-osp-first-name').value,
			last_name: getElement('mmg-osp-last-name').value,
			country: getElement('mmg-osp-country').value,
			membership_plan: getElement('mmg-osp-recurly-plan').value,
			currency: getElement('mmg-osp-currency').value,
			coupon: getElement('mmg-osp-coupon').value,
			current_page: 'upsell',

			has_shipping_address: false,
			// shipping_phone      : getElement( 'mmg-osp-shipping-phone' ).value,
			// shipping_address1   : getElement( 'mmg-osp-shipping-address-1' ).value,
			// shipping_city       : getElement( 'mmg-osp-shipping-city' ).value,
			// shipping_state      : getElement( 'mmg-osp-shipping-state' ).value,
			// shipping_postcode   : getElement( 'mmg-osp-shipping-postcode' ).value,

			with_trial_period: false,
			rc_action: 'subscribe',
		};

		setLoadingState(true);
		jQuery.ajax({
			type: 'POST',
			url: mmgsOneStepPaymentParams.ajaxUrl,
			data: data,
			success: function (responce_data) {
				if (true === responce_data.success) {
					window.location.replace(
						`${mmgsOneStepPaymentParams.redirectUrl}#thank-you-${data.membership_plan}`
					);
				} else {
					if (true === responce_data.data.force_three_d) {
						configure3ds(responce_data.data.three_d_token);
					}

					showError(responce_data.data.error);
				}
				setLoadingState(false);
			},
			error: function (err) {
				const msg =
					typeof err.responseJSON === 'undefined'
						? 'There was an error on creating subscription, please contact to support.'
						: err.responseJSON.message;
				showError(msg);
				setLoadingState(false);
			},
		});
	}

	function configure3ds(three_d_token) {
		const risk = recurly.Risk();
		const threeDSecure = risk.ThreeDSecure({
			actionTokenId: three_d_token,
		});
		getElement('mmg-osp-three-d-secure-action-token-id').value = '';

		threeDSecure.on('token', function (token) {
			getElement('mmg-osp-three-d-secure-action-token-id').value = token.id;

			const paymentMethod = getElement('mmg-osp-payment-form')
				.selected_payment_method.value;
			const tokenId = getElement('mmg-osp-recurly-token').value;
			createSubscription(tokenId, paymentMethod);
			// token.type => 'three_d_secure_action_result'
			// token.id
		});

		threeDSecure.on('error', function (error) {
			showError(error.message);
			// error.code, error.message
		});

		threeDSecure.attach(getElement('mmg-osp-payment-form'));
	}

	function submitForm(form) {
		removeErrorMessage();
		setLoadingState(true);
		const paymentMethod = form.selected_payment_method.value;
		const tokenId = getElement('mmg-osp-recurly-token').value;
		if (paymentMethod === 'credit_card') {
			window.recurly.token(currentCardElements, form, function (err, token) {
				// send any errors to the error function below
				if (err) {
					setLoadingState(false);
					/* Add custom error message */
					recurlyError(err);
				} else {
					createSubscription(token.id, paymentMethod);
				}
			});
		} else {
			if (tokenId) {
				createSubscription(tokenId, paymentMethod);
			} else {
				setLoadingState(false);
				if (paymentMethod === 'paypal') {
					showError('Please connect your PayPal account');
				} else if (paymentMethod === 'apple_pay') {
					showError('Please connect your Apple Pay account');
				} else if (paymentMethod === 'google_pay') {
					showError('Please connect your Google Pay account');
				}
			}
		}
	}

	function setTaxes(tax, taxes, price) {
		const taxContainer = getElement('mmg-osp-tax-container');
		const taxTotalContainer = getElement('mmg-osp-total-tax-container');
		const taxTotal = getElement('mmg-osp-total-tax');
		const annualTotalContainer = getElement('mmg-osp-annual-total-container');

		if (tax && !!parseFloat(tax)) {
			if (jQuery.isArray(taxes) && 'undefined' !== taxes[0].rate) {
				taxTotal.innerText = (
					parseFloat(taxes[0].rate) * parseFloat(price)
				).toFixed(2);
			}
			taxContainer.classList.remove('hidden');
			taxTotalContainer.classList.remove('hidden');
			annualTotalContainer.classList.remove('hidden');
		} else {
			taxTotal.innerText = '';
			taxContainer.classList.add('hidden');
			taxTotalContainer.classList.add('hidden');
			annualTotalContainer.classList.add('hidden');
		}
	}

	function setDiscount(discount) {
		const discountContainer = getElement('mmg-osp-discount-container');

		if (discount && !!parseFloat(discount)) {
			discountContainer.classList.remove('hidden');
		} else {
			discountContainer.classList.add('hidden');
		}
	}

	function setAnnualRecurringTotal(price) {
		const annualRecurringTotal = getElement('mmg-osp-annual-recurring-total');
		const taxTotal = getElement('mmg-osp-total-tax');

		if (taxTotal.innerText) {
			annualRecurringTotal.innerText = (
				parseFloat(price) + parseFloat(taxTotal.innerText)
			).toFixed(2);
		} else {
			annualRecurringTotal.innerText = price;
		}
	}

	function setRegularPrice(tax, discount) {
		const regularPriceContainer = getElement('mmg-osp-regular-price');

		if ((tax && !!parseFloat(tax)) || (discount && !!parseFloat(discount))) {
			regularPriceContainer.classList.remove('hidden');
		} else {
			regularPriceContainer.classList.add('hidden');
		}
	}

	function configureRecurlyPricing() {
		//const pricing = window.recurly.Pricing();
		const pricing = window.recurly.Pricing.Checkout();

		pricing.on('change', function ({ now, next, currency, taxes }) {
			/*setTaxes( next.tax, taxes, next.plan );
			setDiscount( next.discount );
			setAnnualRecurringTotal( next.plan );
			setRegularPrice( next.tax, next.discount );
*/

			setTaxes(next.taxes, taxes, next.subscriptions);
			setDiscount(next.discount);
			setAnnualRecurringTotal(next.subscriptions);
			setRegularPrice(next.taxes, next.discount);


			configureApplePay(currency.code, next.total);
			configureGooglePay(currency.code, next.total, getElement('mmg-osp-payment-form'));
		});

		pricing.attach(getElement('mmg-osp-payment-form'));
	}

	function updatePlanPrices(currency) {
		getElement('mmg-osp-currency').value = currency;

		configureRecurlyPricing();
	}

	function validateFields() {
		let errors = '';

		if (errors.length > 0) {
			showError(errors);
			return false;
		}

		return true;
	}

	function listenTermsCheckboxChange() {
		const tcCheckbox = getElement('mmg-osp-tc-checkbox', true);
		if (tcCheckbox) {
			disableSubmitButtons(!tcCheckbox.checked);
			tcCheckbox.addEventListener('change', function () {
				if (this.checked) {
					disableSubmitButtons(false);
				} else {
					disableSubmitButtons(true);
				}
			});
		}
	}

	function disableSubmitButtons(status) {
		const allSubmitBtns = document.querySelectorAll('#mmg-osp-submit-buttons button');
		for (var i = 0; i < allSubmitBtns.length; i++) {
			allSubmitBtns[i].disabled = status;
		}
	}

	function addListeners() {
		jQuery('#mmg-osp-currency-select').on('change', function () {
			updatePlanPrices(jQuery(this).val());
		});

		const radios = document['mmg-osp-payment'].selected_payment_method;
		radios.forEach(r => {
			r.addEventListener('change', e => {
				setPaymentMethod(e.target.value);
			});
		});

		getElement('mmg-osp-payment-form').addEventListener('submit', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const form = this;
			if (!validateFields()) {
				return;
			}
			submitForm(form);
		});

		getElement('mmg-osp-paypal-submit').addEventListener('click', e => {
			e.preventDefault();
			window.paypal.start();
		});

		listenTermsCheckboxChange();
	}

	function configurePaypal() {
		/* PayPal functionality */
		// Create a recurly.PayPal instance.
		window.paypal = window.recurly.PayPal({
			display: {
				displayName: 'Me And My Golf',
			},
			braintree: {
				clientAuthorization: mmgsOneStepPaymentParams.braintreeTokenizationKey,
			},
		});

		// Handle any errors that occur during the paypal checkout
		paypal.on('error', function (err) {
			document.querySelector('input[name="recurly-token"]').value = '';
			recurlyError(err);
		});


		paypal.on('token', function (token) {
			// Update the token hidden field
			document.querySelector('input[name="recurly-token"]').value = token.id;

			submitForm(getElement('mmg-osp-payment-form'));
		});
	}

	function configureApplePay(currency = '', total = '') {
		// Check if the device is compatible with Apple Pay
		if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
			getElement('mmg-osp-apple-pay-container').innerText = 'Your device or browser is not compatible with Apple Pay';
			return;
		}

		getElement('mmg-osp-selected-payment-method-apple-pay').parentElement.classList.remove('hidden');

		window.applePay = window.recurly.ApplePay({
			country: 'GB', //getElement( 'mmg-osp-country' ).value,
			currency: currency ? currency : getElement('mmg-osp-currency').value,
			total: total ? total : getElement('mmg-osp-total').innerText,
			label: 'Me And My Golf Subscription', // This text will be displayed on the Apple Pay payment sheet
			recurring: true, // Need for Apple starting using MPAN
		});

		// When the ApplePay instance is ready, bind the Apple Pay button click
		window.applePay.ready(function () {
			if (true === window.applePayButtonInited) {
				return;
			}

			window.applePayButtonInited = true;
			var button = document.querySelector('#mmg-osp-apple-pay-submit');

			function initListener() {
				removeErrorMessage();
				window.applePay.begin();
			}

			button.addEventListener('click', initListener);
			button.addEventListener('touch', initListener);
		});

		// Handle errors. These may occur at any point in the Apple Pay flow
		window.applePay.on('error', function (err) {
			document.querySelector('input[name="recurly-token"]').value = '';
			recurlyError(err);
		});

		// This will fire when the flow is completed and a token has been generated
		window.applePay.on('token', function (token) {
			// Update the token hidden field
			document.querySelector('input[name="recurly-token"]').value = token.id;

			submitForm(getElement('mmg-osp-payment-form'));
		});
	}

	function configureGooglePay(currency = '', total = '', form = '') {
		function onPaymentAuthorized(paymentData) {
			const { recurlyToken: token } = paymentData;

			document.querySelector('input[name="recurly-token"]').value = token.id;
			submitForm(getElement('mmg-osp-payment-form'));
		}

		const googlePay = recurly.GooglePay({
			currency: currency,
			country: 'GB', //getElement('country1', true).value,
			total: total,
			googleMerchantId: mmgsOneStepPaymentParams.googleMerchantId,
			// billingAddressRequired: true,
			form: form,
			callbacks: {
				onPaymentAuthorized,
			},
		});

		// When the GooglePay instance is ready, attach the Google Pay Button to the DOM
		googlePay.on('ready', function (googlePayButton) {
			const tcCheckbox = getElement('mmg-osp-tc-checkbox', true);
			if (tcCheckbox) {
				googlePayButton.querySelector('button').disabled = !tcCheckbox.checked;
			}

			getElement('mmg-osp-google-pay-button-container').innerHTML = '';
			getElement('mmg-osp-google-pay-button-container').appendChild(googlePayButton);
		});

		// Handle errors. These may occur at any point in the Google Pay flow
		googlePay.on('error', function (err) {
			// err.code, err.message
			console.error('Google Pay error', err);
		});
	}

	function configureRecurly() {
		window.recurly.configure({
			publicKey: mmgsOneStepPaymentParams.rcPublicKey,
			fraud: {
				kount: {
					dataCollector: true,
					form: getElement('mmg-osp-payment-form'),
				},
			},
		});
		currentCardElements = recurly.Elements();
		const card = currentCardElements.CardElement({
			style: {
				fontFamily: 'Open Sans',
				fontSize: '14px',
				fontColor: '#7b7979',
				placeholder: {
					content: {
						number: 'Card number',
						month: 'MONTH',
						year: 'YEAR',
						cvv: 'CVV',
					},
				},
			},
		});

		card.attach(getElement('mmg-osp-recurly-card'));

		configureRecurlyPricing();
	}

	function init() {
		configureRecurly();
		configurePaypal();
		addListeners();
	}

	init();
});

/**
 * Thank you page.
 */
window.addEventListener('MmgsRecurlyLoaded', () => {
	function getElement(id) {
		return document.getElementById(id);
	}

	function configureRecurlyPricing() {
		const pricing = window.recurly.Pricing.Checkout();
		pricing.attach(jQuery('#mmg-thank-you-exclusive-deal'));

		pricing.on('change', function ({ now, next, currency, taxes }) {
			//jQuery('.price-per-lesson').html((next.subscriptions / 300).toFixed(2));

			if (next.subscriptions === next.total) {
				jQuery('.mmg-btn del').addClass('hidden');
			} else {
				jQuery('.mmg-btn del').removeClass('hidden');
			}
		});
	}

	function init() {
		window.recurly.configure({
			publicKey: mmgsOneStepPaymentParams.rcPublicKey,
		});

		configureRecurlyPricing();
	}

	if (getElement('mmg-thank-you-exclusive-deal')) {
		init();
	}
});
